import { createStyles } from '@mantine/core';

// TODO: RESPONSIVE styles for mobile
const useStyles = createStyles((theme) => ({
  signInContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
    justifyItems: 'center',
    minHeight: '100%',
    background: theme.white,
  },
}));

export default useStyles;
